export const getAllSalesTypesEndpoint = 'sales-types';
